import * as Permissions from '../../permissions';

export default function ({ userHasPermission, showExtendedContext }) {
  let menu = [
    /*{
      label: 'Start',
      href: 'host/#pdf/main',
    },*/
    {
      label: 'Zadania',
      href: 'host/#pdf/tasklist',
      highlightOn: ['host/#pdf/detailsjob', 'host/#pdf/detailsvision'],
    },
    /*
    {
      label: 'Nowe zlecenie',
      href: 'host/#pdf/newTasks',
    },
    {
      label: 'Przepisy',
      href: 'host/#welcome/user-preferences',
      available: userHasPermission(Permissions.LIGHT_MANAGEMENT_MENU),
      children: [
        {
          label: 'Ustawienia indywidualne',
          href: 'host/#welcome/user-preferences',
        },
      ],
    },
    {
      label: 'Komunikacja',
      href: 'host/#pdf/communication',
    },
    {
      label: 'Raporty',
      href: 'host/#pdf/reports',
    },
    
    {
      label: 'Administracja portalu',
      href: 'host/#pdf/administrart',
      available: userHasPermission(Permissions.LIGHT_MANAGEMENT_MENU),
    },
    */
    {
      label: 'Zmiana hasła',
      href: 'host/#welcome/change-password',
    },
  ];

  // Ukrywa "Wnioski" oraz "Oferty" dla pracowników bez uprawnień "showExtendedContext"
  if (!showExtendedContext) {
    menu = menu.filter((item) => item.label !== 'Wnioski' && item.label !== 'Oferty');
  }
  return menu;
}
